import { useAppSelector } from './useAppSelector';
import * as userSlice from '../data/user.slice';

export const useUserClientBC = (): string | null => {
  const userInfo = useAppSelector(userSlice.selectLoggedInUserInfo);
  if (!userInfo) return null;
  if (!userInfo.ids) return null;
  return userInfo.ids.clientBC || null;
};
